import * as React from 'react'
import { Formik } from 'formik'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'

import { useData, useHandlers, useInitialValues, useValidate } from './hooks'
import { RequiredFieldsForm } from './RequiredFieldsForm'
import type {
  RequiredFieldsDialogProps,
  RequiredFieldsFormModel,
} from './typings'

export function RequiredFieldsDialog(props: RequiredFieldsDialogProps) {
  const { leadId, missingFieldIds, onClose } = props

  const data = useData(missingFieldIds)
  const initialValues = useInitialValues(data.missingFields)
  const validate = useValidate(data.customSettings)
  const { onSubmit } = useHandlers({
    leadId,
    missingFields: data.missingFields,
    onClose,
  })

  return (
    <Dialog
      open
      onClose={onClose}
      PaperProps={{ sx: { width: 530 } }}
      data-test-id="required-fields-dialog"
    >
      <DialogTitle sx={{ pt: 3, pb: 0, px: 3 }}>
        Missing Required Fields
      </DialogTitle>
      <Formik<RequiredFieldsFormModel>
        enableReinitialize
        validateOnMount
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        <RequiredFieldsForm data={data} onClose={onClose} />
      </Formik>
    </Dialog>
  )
}

RequiredFieldsDialog.displayName = 'RequiredFieldsDialog'
